import {useLocation} from 'react-router-dom';
import {useDeepCompareMemo} from 'use-deep-compare';

import {type Zoom} from '../../PanelRunsLinePlot/types';

export function useZoomStateFromURL() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const zoom = Array.from(searchParams.entries()).reduce((acc, [key, val]) => {
    if (
      key === 'xAxisMin' ||
      key === 'xAxisMax' ||
      key === 'yAxisMin' ||
      key === 'yAxisMax'
    ) {
      if (val) {
        const numVal = Number(val);
        if (!isNaN(numVal)) {
          acc[key] = numVal;
        }
      }
    }
    return acc;
  }, {} as Partial<Zoom>);

  return useDeepCompareMemo(() => zoom, [zoom]);
}
